module.exports = __webpack_public_path__ + "img/rmkc.77f296cc.png";